import { useEffect, useState } from 'react';

export const useLiveDuration = (startTime?: string, endTime?: string) => {
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    const isJobStillRunning = !endTime && startTime;

    if (isJobStillRunning) {
      const intervalId = setInterval(() => {
        setCurrentTime(Date.now());
      }, 1000);

      return () => clearInterval(intervalId);
    }

    return () => {
      // No cleanup needed when job is completed
    };
  }, [endTime, startTime]);

  return currentTime;
};
